<body class="background">
  <div class="container-fluid h-100">
    @if (loading) {
      <app-loading></app-loading>
    }
    <router-outlet></router-outlet>
  </div>
</body>